var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideMembership({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Light-Pink-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color",
    d: "M7.5 9.80891C7.5 9.19786 7.94177 8.67637 8.5445 8.57592L21.0445 6.49258C21.8064 6.3656 22.5 6.95315 22.5 7.72558V11.25C22.5 11.9404 21.9404 12.5 21.25 12.5H8.75C8.05964 12.5 7.5 11.9404 7.5 11.25V9.80891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Glass",
    filter: "url(#filter0_bi_16_3906)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 20,
    height: 15,
    rx: 2.5,
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 20,
    height: 15,
    rx: 2.5,
    fill: "url(#paint0_linear_16_3906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.125,
    y: 10.125,
    width: 19.75,
    height: 14.75,
    rx: 2.375,
    stroke: "url(#paint1_linear_16_3906)",
    strokeOpacity: 0.1,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Detail",
    filter: "url(#filter1_i_16_3906)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.875,
    cy: 13.125,
    r: 1.875,
    fill: "white",
    fillOpacity: 0.16
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_16_3906",
    x: 2,
    y: 7,
    width: 26,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16_3906"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16_3906",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_16_3906"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_16_3906",
    x: 20,
    y: 11.25,
    width: 3.75,
    height: 4.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16_3906"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_3906",
    x1: 23.7733,
    y1: 24.5841,
    x2: 8.94609,
    y2: 2.85721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3574,
    stopColor: "#FE7B1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC2A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_3906",
    x1: 5.625,
    y1: 10.6818,
    x2: 25,
    y2: 10.6818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD84DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FD6FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideMembership);
export default __webpack_public_path__ + "static/media/side-membership.d845379e1c900affdda6b36cbc095f4b.svg";
export { ForwardRef as ReactComponent };